import React, { useState } from "react";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import { useNavigate } from "react-router-dom";
import newsService from "../Services/newsService";

const AddNews = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    title: "",
    description: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    title: false,
    description: false,
    date: false,
  });

  const [regex, setRegex] = useState({
    title: /.{3,50}$/,
    description: /.{3,50}$/,
    date: /^\d{4}-\d{2}-\d{2}$/,
  });

  const handleChange = (v, n) => {
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });
    console.log(hasError);
    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      newsService.create(data).then((res) => {
        setLoading(false);
        toast.success("News created successfully", { id: "2" });
        navigate("/news");
      });
    }
  };

  return (
      <main className='mx-16 my-10 bg-gray-50 rounded-lg border py-8 px-20'>
        <h1 className='text-center font-bold text-2xl text-gray-700 uppercase'>Add News/Posts</h1>

         <div className='mt-10'>
            <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8">
                  <div>
                      <label className="primary-label">Title</label>
                      <input
                        value={data.title}
                        name="title"
                        onChange={(e) => handleChange(e.target.value, e.target.name)}
                        placeholder="News Title"
                        className={`primary-input ${errors['title'] ? "!border-red-600" : ""}`}
                      />
                </div>
                <div>
                    <label className="primary-label">Date</label>
                    <input
                        type="date"
                        value={data.date}
                        name="date"
                        onChange={(e) => handleChange(e.target.value, e.target.name)}
                        placeholder="Select Date"
                        className={`primary-input ${errors['date'] ? "!border-red-600" : ""}`}
                      />
                </div>
            </div>
             <div className="mt-4">
                 <div>
                    <label className="primary-label">Description</label>
                    <textarea
                        value={data.description}
                        name="description"
                        onChange={(e) => handleChange(e.target.value, e.target.name)}
                        placeholder="News Detail"
                        className={`primary-input ${errors['description'] ? "!border-red-600" : ""}`}
                        rows={3} // You can adjust the rows attribute to control the initial height of the textarea
                      />
                </div>
            </div>
            <div className="flex items-center justify-center mt-12">
                <button
                    onClick={handleSubmit}
                    className={`button-primary ${
                        loading ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                    disabled={loading}
                >
                    {loading ? 'Adding...' : 'Add Location'}
                </button>
            </div>
        </div>
    </main>
  );
};

export default AddNews;
